var map = {
	"./nieruchomości/real-estate-1.jpg": 2174,
	"./nieruchomości/real-estate-2.jpg": 1769,
	"./nieruchomości/real-estate-3.jpg": 6508,
	"./nieruchomości/real-estate-4.jpg": 2823,
	"./nieruchomości/real-estate-5.jpg": 5306,
	"./nieruchomości/real-estate-6.jpg": 9509,
	"./nieruchomości/real-estate-7.jpg": 1896,
	"./nieruchomości/real-estate-8.jpg": 4659,
	"./nieruchomości/real-estate-9.jpg": 9398,
	"./portrety/portrait-1.jpg": 7849,
	"./portrety/portrait-2.jpg": 4766,
	"./portrety/portrait-3.jpg": 6251,
	"./portrety/portrait-4.jpg": 6248,
	"./portrety/portrait-5.jpg": 9765,
	"./portrety/portrait-6.jpg": 7162,
	"./portrety/portrait-7.jpg": 999,
	"./portrety/portrait-8.jpg": 6580,
	"./portrety/portrait-9.jpg": 4625,
	"./z powietrza/aerial-1.jpg": 3708,
	"./z powietrza/aerial-2.jpg": 155,
	"./z powietrza/aerial-3.jpg": 5374,
	"./z powietrza/aerial-4.jpg": 9845,
	"./z powietrza/aerial-5.jpg": 7480,
	"./z powietrza/aerial-6.jpg": 8055,
	"./z powietrza/aerial-7.jpg": 7242,
	"./z powietrza/aerial-8.jpg": 8385,
	"./z powietrza/aerial-9.jpg": 340,
	"./ślubne/wedding-1.jpg": 7582,
	"./ślubne/wedding-2.jpg": 230,
	"./ślubne/wedding-3.jpg": 972,
	"./ślubne/wedding-4.jpg": 1252,
	"./ślubne/wedding-5.jpg": 1130,
	"./ślubne/wedding-6.jpg": 3205,
	"./ślubne/wedding-7.jpg": 8888,
	"./ślubne/wedding-8.jpg": 6499,
	"./ślubne/wedding-9.jpg": 6390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5563;